import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import { rehydrateChildren } from "@tr-digital/react-rehydrate";
import Alert from "../../elements/Alert";
import { AlertState } from "../../elements/Alert/AlertTypes";
import { LoadingState, AjaxContentErrors } from "./AjaxContentTypes";

var AjaxContent = /*#__PURE__*/function (_React$Component) {
  _inherits(AjaxContent, _React$Component);

  var _super = _createSuper(AjaxContent);

  function AjaxContent() {
    var _this;

    _classCallCheck(this, AjaxContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentLocation: null,
      loadingState: LoadingState.UNLOADED,
      retrievedChildren: null
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(AjaxContent.displayName));

    _defineProperty(_assertThisInitialized(_this), "isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "fetchContent", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(location) {
        var fetchResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(location, {
                  credentials: "same-origin"
                });

              case 2:
                fetchResponse = _context.sent;

                if (fetchResponse.ok) {
                  _context.next = 5;
                  break;
                }

                throw new Error("Fetch failed for location: ".concat(location));

              case 5:
                return _context.abrupt("return", fetchResponse.text());

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "loadContent", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var location, isNotLoading, content;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              location = _this.props.location;
              isNotLoading = _this.state.loadingState !== LoadingState.LOADING;

              if (!(isNotLoading || !location || !_this.isMounted)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              _context2.prev = 4;
              _context2.next = 7;
              return _this.fetchContent(location);

            case 7:
              content = _context2.sent;

              _this.renderAjaxChildren(content);

              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);

              _this.handleError(AjaxContentErrors.FETCH_ERROR, _context2.t0);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 11]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderAjaxChildren", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(content) {
        var _this$props, location, reactFromMarkupOptions, reactFromMarkupRehydrators, domNode, retrievedChildren;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = _this.props, location = _this$props.location, reactFromMarkupOptions = _this$props.reactFromMarkupOptions, reactFromMarkupRehydrators = _this$props.reactFromMarkupRehydrators;

                if (_this.isMounted) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;
                domNode = document.createElement("div");
                domNode.innerHTML = content;
                _context3.next = 8;
                return rehydrateChildren(domNode, reactFromMarkupRehydrators, reactFromMarkupOptions);

              case 8:
                retrievedChildren = _context3.sent;

                _this.setState({
                  retrievedChildren: retrievedChildren,
                  currentLocation: location,
                  loadingState: LoadingState.LOADED
                }, _this.handleOnChange);

                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](3);

                _this.handleError(AjaxContentErrors.REHYDRATE_ERROR, _context3.t0);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 12]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.loadingState);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (message, e) {
      // eslint-disable-next-line
      console.error(message, e);

      _this.setState({
        retrievedChildren: null,
        currentLocation: _this.props.location,
        loadingState: LoadingState.FAILED
      }, _this.handleOnChange);
    });

    return _this;
  }

  _createClass(AjaxContent, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                /*
                https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
                TODO: rework this component to rely on promise cancellation
                */
                this.isMounted = true;
                _context4.next = 3;
                return this.loadContent();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.loadContent();

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidUpdate() {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // see componentWillMount for info
      this.isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loadingState = _this$state.loadingState,
          retrievedChildren = _this$state.retrievedChildren;
      var _this$props2 = this.props,
          children = _this$props2.children,
          failedContent = _this$props2.failedContent,
          loadingLabel = _this$props2.loadingLabel,
          minHeight = _this$props2.minHeight;
      var showContent = loadingState !== LoadingState.FAILED;
      var showLoader = loadingState === LoadingState.LOADING;
      var contentClassName = this.getClassName({
        descendantName: "content"
      });
      var baseFontSize = 16;
      /*  eslint no-warning-comments: 0*/

      /*
      eslint-disable
      TODO: make showLoader component
      TODO: make showContent component
      TODO: use css classes instead of style
      eslint-enable
      */

      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        style: minHeight ? {
          minHeight: "".concat(minHeight / baseFontSize, "rem")
        } : {}
      }, showLoader && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "loader"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "loaderLabel",
          utilities: "hiddenVisually"
        })
      }, loadingLabel)), showContent && retrievedChildren && /*#__PURE__*/React.createElement("div", {
        className: contentClassName
      }, retrievedChildren), showContent && !retrievedChildren && /*#__PURE__*/React.createElement("div", {
        className: contentClassName
      }, children), failedContent && loadingState === LoadingState.FAILED && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "failed"
        })
      }, /*#__PURE__*/React.createElement(Alert, {
        alertState: AlertState.FAILURE
      }, failedContent)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      // if we have no content to load, we are done
      if (!nextProps.location && state.retrievedChildren) {
        return {
          currentLocation: null,
          loadingState: LoadingState.LOADED,
          retrievedChildren: null
        };
      } // if location changes, kick off loading


      if (nextProps.location !== state.currentLocation) {
        return {
          loadingState: LoadingState.LOADING
        };
      }

      return state;
    }
  }]);

  return AjaxContent;
}(React.Component);

_defineProperty(AjaxContent, "displayName", "AjaxContent");

_defineProperty(AjaxContent, "defaultProps", {
  location: "",
  failedContent: "Failed to retrieve content",
  loadingLabel: "Loading",
  reactFromMarkupRehydrators: {},
  reactFromMarkupOptions: {
    extra: {}
  }
});

export default AjaxContent;